
function Contact(){

	const urlSearchParams = new URLSearchParams(window.location.search);
	for (var pair of urlSearchParams.entries()) {
		this.addHiddenValue(pair[0], pair[1]);
	}
}


Contact.prototype.addHiddenValue = function (field, value) {
	const input = document.querySelector(`.wpcf7 [name="${field}"]`);
	if (input) {
		input.value = value;
	}
};